import { render, staticRenderFns } from "./ToggleStatus.vue?vue&type=template&id=2a61a002&lang=pug"
import script from "./ToggleStatus.vue?vue&type=script&lang=js"
export * from "./ToggleStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports